var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-250 mx-auto -mt-20"},[_c('FormDatePicker',{attrs:{"label":_vm.question.placeholder,"name":_vm.question.id,"format":"yyyy-MM-dd","hasError":_vm.hasError},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }